export default __webpack_public_path__ + "static/media/qrcode.99a6f356.jpeg";